/*
Cabinets
 */

const name = 'Cabinets'
const id = 'Ykd04XIdh1UeEq4tFect'

export default {
  name,
  id
}
